export default "__VITE_ASSET__Q7AGgfMS2umt67I1yX1$9g__"